<table style="border: 1.5px solid #ccc;margin-bottom: 20px;" cellspacing="0" mat-table [dataSource]="dataSource">
    <tr class="accord-area">
        @for (i of displayedCol; track $index) {
        <ng-container matColumnDef={{i}}>
            <th mat-header-cell class="scrollable" *matHeaderCellDef>
                <div>{{i}}</div>
            </th>
            <td class="scrollable" mat-cell *matCellDef="let element">
                <div class="border-class">
                    {{element[i]}}
                </div>
            </td>
        </ng-container>
        }
    </tr>
    <tr mat-header-row *matHeaderRowDef="displayedCol"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedCol;"></tr>
</table>